import type {
    TaskEventOperationTypes,
    PVOptions,
    TaskOptions,
    CustomOptions,
    EventOptions,
    ShowEventOptions,
    UrlPage,
} from '@/config/types';
import type { SendEventTypes } from '@/types/event';
import type { CurrentPageOptions, ElementShowEventOptions, CustomStatEventOptions, TaskEventOptions } from './types';
import { isKDSNative } from '@/util/ua';

export function logFactory(type: SendEventTypes, data: EventOptions) {
    const {
        action,
        params,
        eventId,
        contentPackage,
        currentUrlPackage,
        status = 'SUCCESS',
        name,
        feedLogCtx,
    } = data as ShowEventOptions;
    if (type === 'PV') {
        const { type: actionType, beginTime } = data as PVOptions;
        return {
            ...currentUrlPackage,
            actionType,
            contentPackage,
            status,
            beginTime,
            eventId,
            pageType: isKDSNative() ? 'NATIVE' : 'H5',
        } as CurrentPageOptions;
    }
    let urlPage: UrlPage | undefined;
    if (currentUrlPackage) {
        const { page, params, identity, coPage } = currentUrlPackage;
        urlPage = {
            page,
            params,
            identity,
            coPage,
        };
    }
    if (['RADAR', 'CUSTOM', 'CUSTOM_EVENT'].includes(type)) {
        const { key, value, biz } = data as CustomOptions;
        return {
            key,
            value: JSON.stringify({
                ...value,
                url_package: currentUrlPackage,
            }),
            biz,
            eventId,
            urlPage
        } as CustomStatEventOptions;
    }
    const elementLogParams: ElementShowEventOptions = {
        action,
        params: JSON.stringify(params),
        contentPackage,
        feedLogCtx,
        eventId,
        urlPage
    };
    if (type !== 'SHOW') {
        const { type: taskType } = data as TaskOptions;
        Object.assign(elementLogParams as TaskEventOptions, {
            type: taskType || 'USER_OPERATION',
            status: status || 'UNKNOWN_STATUS',
            operationType: type as TaskEventOperationTypes,
            operationDirection: 'UNKNOWN2',
        });
    }
    return elementLogParams;
}
